import React from 'react';
import { CheckCircle2Icon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const rows = [['Horas preparando desde cero', 'Planificación lista para todo el año'], ['Ideas sueltas sin progresión', '12 tomos por año y nivel'], ['Clases repetidas o improvisadas', '400+ sesiones para ejecutar'], ['Alumnos desconectados', 'Juegos, ejercicios y objetivos claros'], ['Llegar al patio sin seguridad', 'Cada clase organizada y lista para enseñar']];
export function FinalCTA() {
  return <section className="border-y-4 border-emerald-400 bg-[#09281d] px-5 py-20" data-id="element-36" data-mp="vui656o2ncdm">
      <div className="mx-auto max-w-3xl text-center" data-id="element-37" data-mp="vwkrhdea4hc0">
        <h2 className="font-display text-4xl font-bold uppercase leading-none text-white sm:text-6xl" data-id="element-38" data-mp="qwztp6auif0v">
          Dejá de improvisar.{' '}
          <span className="text-emerald-300" data-id="element-39" data-mp="14t3k0oilm382">
            Empezá a enseñar con un sistema.
          </span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl font-medium leading-relaxed text-slate-300" data-id="element-40" data-mp="2c4wmkk3t04fa">
          Unite a los cientos de profesores que ya planifican su año en menos de
          5 minutos.
        </p>
        <p className="mt-5 text-xs font-bold uppercase tracking-[.18em] text-emerald-200" data-id="element-41" data-mp="2m33zmruz22c0">
          12 Tomos · 5 Bonos · 400+ Sesiones · Toda la trayectoria escolar
        </p>
        <div className="mt-10 overflow-hidden border border-emerald-300/30 text-left" data-id="element-42" data-mp="2qzkqhttk2uss">
          <div className="grid grid-cols-2 bg-[#10372a] text-center text-[10px] font-bold uppercase tracking-widest" data-id="element-43" data-mp="2v1g2bs944qkt">
            <p className="p-4 text-slate-300" data-id="element-44" data-mp="34tbzn13dkcnz">Sin Educación Física Lista™</p>
            <p className="border-l border-emerald-300/30 p-4 text-emerald-300" data-id="element-45" data-mp="34vf0kg62fq7h">
              Con Educación Física Lista™
            </p>
          </div>
          {rows.map(([without, withSystem]) => <div key={without} className="grid grid-cols-2 border-t border-emerald-300/20 text-xs sm:text-sm" data-id="element-46" data-mp="3epf2ya9yqhci">
              <p className="flex gap-2 p-4 font-medium text-slate-300" data-id="element-47" data-mp="1jpembk3tbiw7">
                <span className="text-red-400" data-id="element-48" data-mp="1epij3n2xvvhp">×</span>
                {without}
              </p>
              <p className="flex gap-2 border-l border-emerald-300/20 bg-emerald-300/5 p-4 font-semibold text-white" data-id="element-49" data-mp="1sgeww7s7i84p">
                <CheckCircle2Icon className="h-4 w-4 shrink-0 text-emerald-300" data-id="element-50" data-mp="1npopyq44tx7w" />
                {withSystem}
              </p>
            </div>)}
        </div>
        <div className="my-9" data-id="element-51" data-mp="1xfqefj0edhnc">
          <CountdownTimer dark data-id="element-52" data-mp="1xgjczwp7d0ue" />
        </div>
        <div className="border-2 border-emerald-400 bg-[#10372a] p-7 text-left" data-id="element-53" data-mp="1xhufzuatq4kg">
          <p className="text-xs font-bold uppercase tracking-widest text-emerald-300" data-id="element-54" data-mp="2bezlnt6ml1f6">
            Paquete completo
          </p>
          <h3 className="mt-2 text-xl font-bold text-white" data-id="element-55" data-mp="27c35080nbfdv">
            PACK EDUCACIÓN FÍSICA LISTA™ — 12 Tomos + 5 Bonos
          </h3>
          <div className="mt-5 flex items-end justify-between" data-id="element-56" data-mp="d0oj62ara03e">
            <div data-id="element-57" data-mp="2vyaldkujxq7">
              <p className="text-sm font-bold text-slate-300" data-id="element-58" data-mp="2vg6xvvuuh89">
                Oferta de lanzamiento
              </p>
              <p className="font-display text-6xl font-bold leading-none text-white" data-id="element-59" data-mp="6wi66cpruta8">
                $17 USD
              </p>
            </div>
            <p className="bg-emerald-400 px-3 py-2 text-xs font-bold uppercase text-[#09281d]" data-id="element-60" data-mp="3p9gaevtlk8a7">
              Acceso de por vida
            </p>
          </div>
        </div>
        <a href="https://pack-e-f-lista.impultienda.ar/checkout" className="cta-button mt-8 block w-full rounded-2xl px-5 py-5 text-lg font-bold sm:text-xl" data-id="element-61" data-mp="3fbtk7d6ukuax">
          OBTENER EDUCACIÓN FÍSICA LISTA AHORA
        </a>
        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-300" data-id="element-62" data-mp="3bbi0c2mb6y0i">
          <span className="flex gap-1" data-id="element-63" data-mp="14ksdn78bu98q">
            <LockKeyholeIcon className="h-4 w-4 text-emerald-300" data-id="element-64" data-mp="14lv45e1qm9o4" /> Pago seguro
          </span>
          <span className="flex gap-1" data-id="element-65" data-mp="19jwkhr7s3uvw">
            <ZapIcon className="h-4 w-4 text-emerald-300" data-id="element-66" data-mp="35njc2eko99j4" /> Acceso instantáneo
          </span>
          <span className="flex gap-1" data-id="element-67" data-mp="30ogk9vtpczt3">
            <ShieldCheckIcon className="h-4 w-4 text-emerald-300" data-id="element-68" data-mp="30phyg960m2f1" /> Garantía de
            7 días
          </span>
        </div>
      </div>
    </section>;
}